module.exports = __webpack_public_path__ + "img/moto.8ddf3075.png";